import Ui from "./ui.es6";
import Modal from "./modal.es6";
import Scroll from "./scroll.es6";

export default class Common {
    constructor() {
        this.ui = new Ui();
        this.modal = new Modal();
        this.scroll = new Scroll();
        this.init();
    }

    init() {}
}
